export default {
  default: {
    edit: 'Edit',
    goBack: 'Go Back',
    preview: 'Preview',
    title: 'Digital Page',
  },
}
